/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";

import MDBox from "components/MDBox";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { DatePicker, Tag } from "antd";
import Tooltip from "@mui/material/Tooltip";
import { useMaterialUIController } from "context";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";

import { useNavigate } from "react-router-dom";

// import DownloadsIcon from "../../assets/images/download.svg";

// import ActivePieCard1 from "examples/Cards/InfoCards/ActivePieCard/ActivePieCard1";
// import EnergyConsumptionCard from "examples/Cards/InfoCards/EnergyConsumptionCard";
import MDButton from "components/MDButton";
import useApiRequest from "utils/Apirequest";
import Loader from "components/custom/Loader";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import { AutoTooltip } from "utils/Constant";
import { convertUTCtoDubai } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";
import Resolved from "../../assets/cms-icons/Resolved.png";
// const { RangePicker } = DatePicker;

const Faultdetection = () => {
  const apiRequest = useApiRequest();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [faultData, setFaultData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [values1, setValues1] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [solution, setSolution] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [isFaultTableLoading, setIsFaultTableLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);



  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const handleSearchChange = (value) => {
    const searchValue =
      typeof value === "string"
        ? value
        : value?.target?.value ?? "";

    setSearchText(searchValue);
    setPage(0);
  };

  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  const handleSolve = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const fetchFaults = async () => {
    setIsFaultTableLoading(true);

    const { data } = await apiRequest(
      "get",
      `faults/?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"
      }&search=${searchText}`
    );

    if (data?.success) {
      setRows(data.data);
      setTotalRows(data.total);
    }

    setIsFaultTableLoading(false);
  };

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
      return;
    }
    fetchFaults();
  }, [page, pageSize, sorting, searchText]);



  const handleSubmitSolution = async () => {
    if (!selectedRow) return;
    const username = getDecodedUserData()?.username

    const payload = {
      solvedMessage: `${solution}. Resolved by - ${username}`,
    };

    try {
      const { data } =
        (await apiRequest(
          "put",
          `faults/${selectedRow._id}`,
          payload,
          {},
          {
          }
        )) || {};
      if (data?.status || data?.success) {
        setOpenDialog(false);
        setSolution("");
        fetchFaults();
      }
    } catch (err) {
      console.error("API error", err);
    }
  };

  const statusList = ["Fault", "Solved"];


  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const column = [
    {
      header: "Status",
      accessorKey: "status",
      filterVariant: "select",
      size: 200,
      filterSelectOptions: statusList,
      align: "center",
      fixed: "true",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          bgcolor="rgba(25, 128, 56, 0.2)"
          style={{
            flex: 1,
          }}
        >
          <Tag
            color={
              row.row.original.status === "Fault"
                ? "red"
                : row.row.original.status === "Solved"
                  ? "green"
                  : "yellow"
            }
          >
            {row.row.original.status}
          </Tag>
        </MDBox>
      ),
    },
    {
      header: "Charger ID",
      accessorKey: "chargerId",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Charger Name",
      accessorKey: "chargerName",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Connector ID",
      accessorKey: "connectorId",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Location Name",
      accessorKey: "locationName",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Issue",
      accessorKey: "issue",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: 'center',
        Cell: ({ cell }) => {
          const issue = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={250}>{issue}</AutoTooltip>;
        }
      },
      Cell: ({ cell }) => {
        const message = cell.getValue() || ' ';
        return <AutoTooltip maxWidth={150}>{message}</AutoTooltip>;
      }
    },

    {
      header: "Error Code",
      accessorKey: "errorCode",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    // {
    //   header: "Severity",
    //   accessorKey: "severity",
    //   align: "center",
    //   size: 200,
    //   muiTableHeadCellProps: {
    //     align: "center",
    //   },
    //   muiTableBodyCellProps: {
    //     align: "center",
    //   },
    // },
    {
      header: "Solved Message",
      accessorKey: "solvedMessage",
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        const value = cell.getValue();

        return value && value.trim() !== "" ? value : "N/A";
      },
    },

    {
      header: "Timestamp",
      accessorKey: "timestamp",
      enableColumnFilter: false,
      align: "center",
      size: 250,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },

    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      align: "center",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div
          key={`action-cell-${row.row.id}-${sidenavColor}`}
          style={{
            position: "sticky",
            right: "0",
          }}
        >
          {row?.row?.original?.status === "Fault" ? (
            <MDButton
              onClick={() => handleSolve(row.row.original)}
              variant="gradient"
              color={sidenavColor}
              iconOnly
            >
              <img
                src={Resolved}
                alt="Resolved"
                style={{
                  width: "22px",
                  height: "22px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </MDButton>
          ) : "N/A"}
        </div>
      ),
    },
  ];

  // eslint-disable-next-line no-unused-vars
  // const [fromDate, setFromDate] = useState(null);
  // // eslint-disable-next-line no-unused-vars
  // const [toDate, setToDate] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const [timeRange] = useState("last30");

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    handleDownloadExcelSingle();
    handleMenuClose();
  };

  const [rows, setRows] = useState([]);
  const [graphData] = useState({});
  const navigate = useNavigate();

  const [selectedTitle] = useState("User");
  const [selectedLabels] = useState(graphData?.labels || []);
  const [selectedData] = useState(faultData?.summary?.faultValues || []);

  const handleDownloadExcelSingle = async () => {
    if (!selectedTitle || !selectedLabels || !selectedData) {
      console.error("Some data is missing!");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const createStyledSheet = (sheetName, data) => {
      const sheet = workbook.addWorksheet(sheetName);

      const headerRow = sheet.addRow(["Labels", ...labels]);
      headerRow.font = { bold: true, size: 14 };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
        };
      });

      sheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
      sheet.columns.forEach((column) => {
        column.width = 15;
      });
    };
    createStyledSheet("Faults", values1);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "cms_chrgup_data.xlsx");
  };

  const pieChartData = {
    labels: ["Fault", "Solved"],
    datasets: {
      data: [
        faultData?.summary?.currentFaults || 0,
        faultData?.summary?.completedFaults || 0,
      ],
      backgroundColors: ["info", "success"],
    },
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Dialog open={openDialog} fullWidth onClose={handleCloseDialog}>
        <DialogTitle
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
          className="dialogtitle"
        >
          Fault Resolution
        </DialogTitle>
        <DialogContent
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
        >
          <TextField
            fullWidth
            label="Solution"
            value={solution}
            onChange={(e) => setSolution(e.target.value)}
            margin="normal"
            multiline
            rows={3}
          />
          <div style={{ marginTop: "16px", textAlign: "end" }}>
            <MDButton
              variant="contained"
              danger
              color="error"
              onClick={handleCloseDialog}
              style={{
                marginRight: "1rem",
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              onClick={handleSubmitSolution}
            >
              Solve
            </MDButton>
          </div>
        </DialogContent>
      </Dialog>

      <MDBox>
        {/* <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={8} mb={3}>
            <Card sx={{ height: "100%" }}>
              <MDBox padding="1rem">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "1rem",
                    paddingRight: "1rem",
                    flexDirection: window.innerWidth < 600 ? "column" : "row",
                    gap: "0.5rem",
                  }}
                >
                  <MDTypography
                    variant="h5"
                    fontWeight="medium"
                    sx={{
                      fontSize: { xs: "1.05rem", sm: "1.15rem", md: "1.25rem" },
                      textAlign: { xs: "left", sm: "left" },
                    }}
                  >
                    Fault Detection
                  </MDTypography>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {timeRange === "custom" && (
                      <RangePicker
                        size="medium"
                        format="YYYY-MM-DD"
                        onChange={(value, dateString) => {
                          setFromDate(dateString[0]);
                          setToDate(dateString[1]);
                        }}
                      />
                    )}

                    <IconButton
                      onClick={handleDownload}
                      sx={{
                        width: "2rem",
                        height: "2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#FFF",
                        border: "1px solid #E3E3E3",
                        padding: "5px",
                        borderRadius: "8px",
                        transition: "background-color 0.3s ease",
                        "&:hover": {
                          backgroundColor: "#A6DBFF",
                        },
                      }}
                    >
                      <img
                        src={DownloadsIcon}
                        alt="Download"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          objectFit: "contain",
                        }}
                      />
                    </IconButton>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleDownload}>Download</MenuItem>
                    </Menu>
                  </div>
                </div>

                <EnergyConsumptionCard
                  title="Fault"
                  labels={labels}
                  data1={values1}
                  colorcode="#e94440"
                />
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            <MDBox mb={3}>
              <ActivePieCard1 chart={pieChartData} />
            </MDBox>
          </Grid>
        </Grid> */}
      </MDBox>
      <MDBox mt={8}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={1}
            px={2}
            variant="gradient"
            bgColor={sidenavColor}
            borderRadius="lg"
            coloredShadow={sidenavColor}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography
                variant="h6"
                color="white"
                style={{
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: "600",
                  lineHeight: "29.26px",
                }}
              >
                Faults
              </MDTypography>
            </Grid>
          </MDBox>
          <div style={{ position: "relative" }}>
            {isFaultTableLoading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 10,
                  background: "rgba(255,255,255,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader />
              </div>
            )}

            <CustomMaterialTablePage
              columns={column}
              data={rows}
              darkMode={darkMode}
              manualPagination={true}
              manualFiltering={false}
              rowCount={totalRows}
              paginationChange={(newPage) => setPagination(newPage)}
              soringChange={handleSortingChange}
              page={page}
              pagesize={pageSize}
              paginataion={pagination}
              sorting={sorting}
              searchText={searchText}
              searchChange={handleSearchChange}
              onColumnFiltersChange={setColumnFilters}
              onColumnVisibilityChange={setColumnVisibility}
              state={{
                pagination,
                sorting,
                columnFilters,
                columnVisibility,
              }}
              globalFilterDebounceMs={2000}
            />
          </div>

        </Card>
      </MDBox>
    </DashboardLayout>
  );
};

export default Faultdetection;
